import { useEffect, type ReactNode } from 'react'

/**
 * RHS slide-over panel (decision 30) — detail and edit views open here rather
 * than navigating away or growing the table sideways.
 */
export function SlideOver({
  title, subtitle, onClose, children, footer, wide = false,
}: {
  title: string
  subtitle?: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  /** Decision 211: a panel carrying a wide table (the supplier-quote preview) takes 960px. */
  wide?: boolean
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <>
      <div className="scrim" onClick={onClose} />
      <aside className={wide ? 'slideover slideover--wide' : 'slideover'} role="dialog" aria-modal="true" aria-label={title}>
        <header className="slideover__head">
          <div>
            <h2>{title}</h2>
            {subtitle && <p className="muted small" style={{ margin: '4px 0 0' }}>{subtitle}</p>}
          </div>
          <button className="btn btn--ghost" onClick={onClose} aria-label="Close panel">✕</button>
        </header>
        <div className="slideover__body">{children}</div>
        {footer && <footer className="slideover__foot">{footer}</footer>}
      </aside>
    </>
  )
}
